module.exports = __webpack_public_path__ + "img/Goin_8.5313b5cc.jpg";